import React, { useState, useEffect, useRef } from "react";
import useSiteData from '../../useSiteData'
import Link from "../atoms/Link";
import Sticky from 'react-stickynode';


export default ({ overviewText = "Overview", parentSlug, productCode, subPages, selectedIndex, hideInContentSelector }) => {
    const [sticky, setSticky] = useState(false);
    const element = useRef(null);
    const { translations } = useSiteData().pageSettings;
    const slug = useSiteData().checkoutSlug;
    const parentLink = { internalLink: { slug: parentSlug } };
    /* turning off book now button but leaving code here if it is enabled again */
    /*
    const checkoutLink = productCode ? {
        internalLink: { slug },
        anchor: { anchorName: productCode.toUpperCase() }
    } : null;
    */
    const checkoutLink = null

    const handleStateChange = (status) => {
        setSticky(status.status === Sticky.STATUS_FIXED);
    }

    useEffect(() => {
        element.current.scrollLeft = 0;
    }, [parentSlug]);

    useEffect(() => {
        document.activeElement.blur(); // release focus
        
        // make sure that selected link is visible
        const stickyWidth = element.current.offsetWidth    
        const activeLink = element.current.children[selectedIndex]

        // subpages special should not show in the content selector. so if we are on a subpage special don't try to calculate here. the property is set during the build see gatsby-node.esm.js
        if( hideInContentSelector ) {
            element.current.scrollLeft = 0
        }
        else if( stickyWidth < activeLink.offsetLeft + activeLink.offsetWidth ) {
            element.current.scrollLeft = activeLink.offsetLeft - ( ( stickyWidth - activeLink.offsetWidth ) / 2)
        }

    }, [selectedIndex]);

    return (
        <Sticky enabled={true} innerZ={999} onStateChange={handleStateChange}>
            <section
                className={ "o-link-list o-link-list--short " +
                (sticky ? "o-link-list--sticky" : "") }
                ref={ element }
            >

                <Link
                    className={ "o-link-list__item" + (selectedIndex === 0 ? " o-link-list__item--active" : "") }
                    link={ parentLink }
                >
                    { overviewText }
                </Link>
                { subPages.map(({ slug, navigationTitle, title }, index) => {
                        const subPageLink = {
                            internalLink: { slug: parentSlug + "/" + slug },
                            anchor: { anchorName: slug }
                        };
                        return (
                            <Link
                                className={ "o-link-list__item" + (selectedIndex === index + 1 ? " o-link-list__item--active" : "") }
                                link={ subPageLink }
                                key={ index }
                            >
                                { navigationTitle || title }

                            </Link>
                        );
                    }
                ) }
                { checkoutLink &&
                <Link className="a-btn a-btn--red u-margin-right" link={ checkoutLink }>
                    { (translations.book ? translations.book : "Book") }
                </Link>
                }
            </section>
        </Sticky>
    );
}
